import { colorPalette } from '../../../colorPalette';
export const getCardOfferStyles = (format) => ({
    container: {
        position: 'relative',
        backgroundColor: colorPalette.white,
        minWidth: format === 'vertical' ? '80px' : '130px',
        width: '100%',
        padding: '12px',
        borderRadius: '8px',
        border: `1px solid ${colorPalette.gray200}`,
        cursor: 'pointer',
        ':hover': {
            backgroundColor: colorPalette.gray100,
            transition: 'linear 0.2s',
        },
        ':focus': {
            backgroundColor: colorPalette.gray100,
            outline: `1px solid ${colorPalette.lightBlue800}`,
            outlineOffset: '1px',
            transition: 'linear 0.2s',
        },
    },
});
export const selectedStyle = {
    backgroundColor: colorPalette.gray100,
    border: `1px solid ${colorPalette.gray900}`,
    transition: 'linear 0.2s',
    '.clearIcon': {
        display: 'inline-block',
    },
};
export const titleStyle = (isNotNew) => ({
    color: isNotNew ? colorPalette.green700 : colorPalette.gray800,
});
export const overflowEllipsisStyle = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
};
export const iconContainer = (isNotNew) => ({
    width: '32px',
    height: '32px',
    padding: '6px',
    backgroundColor: isNotNew ? colorPalette.green100 : colorPalette.gray100,
    borderRadius: '8px',
});
export const clearIconStyle = {
    display: 'none',
    color: colorPalette.gray700,
    height: '20px',
    width: '20px',
    position: 'absolute',
    right: '12px',
    top: '12px',
};
